import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=0beef68c&scoped=true&"
import script from "./Section8.vue?vue&type=script&lang=js&"
export * from "./Section8.vue?vue&type=script&lang=js&"
import style0 from "./Section8.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section8.vue?vue&type=style&index=1&id=0beef68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beef68c",
  null
  
)

export default component.exports